export const formatSpace = (space) => {
  return space === 1 ? 'Solar da Levada' : space === 2 ? 'Quinta Lago dos Cisnes' : '';
}